var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHumans = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 20,
  viewBox: "0 0 8 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Humans"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M3.84375 0C4.37418 0 4.88289 0.210714 5.25796 0.585786C5.63304 0.960859 5.84375 1.46957 5.84375 2C5.84375 2.53043 5.63304 3.03914 5.25796 3.41421C4.88289 3.78929 4.37418 4 3.84375 4C3.31332 4 2.80461 3.78929 2.42954 3.41421C2.05446 3.03914 1.84375 2.53043 1.84375 2C1.84375 1.46957 2.05446 0.960859 2.42954 0.585786C2.80461 0.210714 3.31332 0 3.84375 0ZM2.34375 5H5.34375C5.87418 5 6.38289 5.21071 6.75796 5.58579C7.13304 5.96086 7.34375 6.46957 7.34375 7V12.5H5.84375V20H1.84375V12.5H0.34375V7C0.34375 6.46957 0.554464 5.96086 0.929537 5.58579C1.30461 5.21071 1.81332 5 2.34375 5Z",
  fill: "#999999"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHumans);
export { ForwardRef as ReactComponent };